import { SurveyModel } from '@psyomics/surveyjs-core';

function isSurveyQuestionFocused(survey: SurveyModel): boolean {
  const { activeElement } = document;
  if (!activeElement) return false;

  const questionName = activeElement.closest('[data-name]')?.getAttribute('data-name');
  if (!questionName) return false;

  const question = survey.getQuestionByName(questionName);
  return Boolean(question);
}

export { isSurveyQuestionFocused };
